import { resourceListBindings } from 'tmr/components/resourceList/resourceListHelper'
import templateUrl from './users.html'

/**
 * Administer Users route
 *
 * @namespace routes.AdminUsers
 * @type {TmrRoute}
 */
export const route = {
  name: 'admin.users.list',
  label: 'ADMIN.USERS.TITLE',
  url: '/users',
  component: 'tmrAdminUsers',
  weight: 4,
  resourceType: 'User',
  resourceList: {
    searchParameters: [
      'username',
      'name',
      'surname',
      'email',
      'place.id',
      'admin',
    ],
  },
}

/**
 * Component for {@link routes.tmrAdminUsers Administer Users route}
 *
 * @type {ngComponent}
 */
export const tmrAdminUsers = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrAdminUsersController',
  bindings: resourceListBindings({
    loggedUser: '<',
  }),
}

/**
 * Controller of component {@link tmrAdminUsers}.
 *
 * @type {ngController}
 */
export class tmrAdminUsersController {
  static ngType = 'controller'

  constructor(TmrApiAuth, TmrLoginModal, TmrPromptModal, TmrSerialQ, TmrToast) {
    'ngInject'
    Object.assign(this, {
      TmrApiAuth,
      TmrLoginModal,
      TmrPromptModal,
      TmrSerialQ,
      TmrToast,
    })
  }

  $onInit() {
    this.accessDeleteOp = this.resources.reduce(
      (acc, { id }) => Object.assign(acc, { [id]: id != this.loggedUser.id }),
      {}
    )
    this.TmrSerialQ(this.resources, user => user.$get())
  }

  askResetPassword($event, userId) {
    this.TmrPromptModal($event, {
      question: 'ADMIN.USERS.RESOURCELIST.RESETPASSWORDQUESTION',
      yesCallback: () => this.resetPassword(userId),
      relativeTo: `.reset-password-${userId}`,
    })
  }

  resetPassword(id) {
    this.TmrApiAuth.resetPasswordAdmin(id)
      .then(token =>
        this.TmrToast.success(
          'ADMIN.USERS.RESOURCELIST.RESETPASSWORDSENT',
          {
            username: this.resources.find(user => user.id == id).username,
            code: token,
          },
          null,
          true
        )
      )
      .catch(err => this.TmrToast.exception(err))
  }

  loginAs($event, username) {
    this.TmrLoginModal($event, username)
  }
}
